import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FeeSystemMenu from "./FeeSystemMenu";
import RightsCheck from "../General/RightsCheck";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";
import config from "../../Config";

const MONTH_OPTIONS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

function pickPreviewRows(res) {
  const d = res?.data;
  if (!d) return [];
  return d.PreviewRows || d.previewRows || [];
}

function AttendanceFineBatch() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const now = new Date();
  const [sessionId, setSessionId] = useState(
    () => parseInt(localStorage.getItem("DefaultSession"), 10) || 0
  );
  const [wingId, setWingId] = useState(0);
  const [classId, setClassId] = useState(0);
  const [sectionId, setSectionId] = useState(0);

  const [attMonth, setAttMonth] = useState(now.getMonth() + 1);
  const [attYear, setAttYear] = useState(now.getFullYear());
  const [invMonth, setInvMonth] = useState(now.getMonth() + 1);
  const [invYear, setInvYear] = useState(now.getFullYear());

  const [fineKind, setFineKind] = useState("Absent");
  const [tierAbsent, setTierAbsent] = useState(true);
  const [rateJunior, setRateJunior] = useState(10);
  const [rateSenior, setRateSenior] = useState(50);
  const [replaceMonthly, setReplaceMonthly] = useState(false);
  const [mergeExistingFeeLine, setMergeExistingFeeLine] = useState(true);

  const [previewRows, setPreviewRows] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [posting, setPosting] = useState(false);

  useEffect(() => {
    document.title = "Attendance fines (challan)";
  }, []);

  useEffect(() => {
    setClassId(0);
    setSectionId(0);
  }, [sessionId, wingId]);

  useEffect(() => {
    setSectionId(0);
  }, [classId]);

  const buildPayload = (previewOnly) => ({
    AccessKey,
    UserID: parseInt(UserID, 10) || 0,
    MemberType: MemberType || "Admin",
    SchoolID: 1,
    SessionID: parseInt(sessionId, 10) || 0,
    Wing_Id: parseInt(wingId, 10) || 0,
    Class_Id: parseInt(classId, 10) || 0,
    Section_Id: parseInt(sectionId, 10) || 0,
    AttendanceMonth: parseInt(attMonth, 10) || 1,
    AttendanceYear: parseInt(attYear, 10) || now.getFullYear(),
    InvoiceMonth: parseInt(invMonth, 10) || 1,
    InvoiceYear: parseInt(invYear, 10) || now.getFullYear(),
    FineKind: fineKind === "Late" ? "Late" : "Absent",
    UseClassTieringForAbsent: fineKind === "Absent" ? tierAbsent : false,
    RateJuniorPerOccurrence: parseInt(rateJunior, 10) || 0,
    RateSeniorPerOccurrence: parseInt(rateSenior, 10) || 0,
    ReplaceMonthlyChalanWhenAttachingOtherDues: replaceMonthly,
    MergeIntoExistingFeeLineOnChalan: mergeExistingFeeLine,
    PreviewOnly: previewOnly,
  });

  const runPreview = () => {
    if (!parseInt(sessionId, 10)) {
      toast.error("Select a session.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    setLoadingPreview(true);
    setPreviewRows([]);
    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/PostAttendanceFinesChallan",
      headers: { "Content-Type": "application/json" },
      data: buildPayload(true),
      timeout: 120000,
    })
      .then((res) => {
        if (res.data?.status_code !== 1) {
          toast.error(res.data?.status_message || "Preview failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }
        const rows = pickPreviewRows(res);
        setPreviewRows(Array.isArray(rows) ? rows : []);
        toast.success(
          rows.length
            ? `Preview: ${rows.length} student(s).`
            : "No rows match the filters.",
          { position: toast.POSITION.TOP_RIGHT }
        );
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setLoadingPreview(false));
  };

  const runPost = () => {
    if (!parseInt(sessionId, 10)) {
      toast.error("Select a session.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (!previewRows.length) {
      toast.error("Run preview first.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    if (
      !window.confirm(
        `Post ${fineKind === "Late" ? "late comer" : "absent"} fines for ${previewRows.length} student(s) on challan month ${invMonth}/${invYear}? This updates tblChalanHead + tblADLedger (not tblStudentLedger).`
      )
    ) {
      return;
    }
    setPosting(true);
    axios({
      method: "post",
      url: config.base_url + "ChallanFeeSystem/PostAttendanceFinesChallan",
      headers: { "Content-Type": "application/json" },
      data: buildPayload(false),
      timeout: 600000,
    })
      .then((res) => {
        if (res.data?.status_code === 1) {
          toast.success(res.data?.status_message || "Posted.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          });
          setPreviewRows([]);
        } else {
          toast.error(res.data?.status_message || "Post failed.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 10000,
          });
        }
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setPosting(false));
  };

  const yearOpts = () => {
    const y = now.getFullYear();
    const o = [];
    for (let i = y - 2; i <= y + 1; i++) o.push(i);
    return o;
  };

  return (
    <>
      <FeeSystemMenu />
      <RightsCheck />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/Dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/FeeSystem/FeeSystemDashboard">Fee System</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Attendance fines (batch)
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Attendance fines (challan / AD ledger)</div>
                <p className="text-muted small mb-0">
                  Replaces legacy <code>tblStudentLedger</code> inserts for absent (003 / A·AB) and late
                  comer (004 / LC). Counts come from <code>tblStudentAttendence</code>; amounts post on the{" "}
                  <strong>monthly challan</strong> for the invoice month you choose (same rules as{" "}
                  <Link to="/FeeSystem/AddAbsentFine" onClick={scrollToTop}>
                    Add Absent Fine
                  </Link>
                  ).
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card mb-3">
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">Session</label>
                    <select
                      className="form-select"
                      value={sessionId}
                      onChange={(e) => setSessionId(parseInt(e.target.value, 10) || 0)}
                      required
                    >
                      <option value={0}>Select session</option>
                      <SessionsDropDown selectedSession={sessionId} />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Wing</label>
                    <select
                      className="form-select"
                      value={wingId}
                      onChange={(e) => setWingId(parseInt(e.target.value, 10) || 0)}
                    >
                      <option value={0}>All wings</option>
                      <WingsDropDown selectedWingId={wingId} />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Class</label>
                    <select
                      className="form-select"
                      value={classId}
                      onChange={(e) => setClassId(parseInt(e.target.value, 10) || 0)}
                    >
                      <option value={0}>All classes</option>
                      <ClassesDropDown SessionID={sessionId} WingID={wingId} />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Section</label>
                    <select
                      className="form-select"
                      value={sectionId}
                      onChange={(e) => setSectionId(parseInt(e.target.value, 10) || 0)}
                    >
                      <option value={0}>All sections</option>
                      <SectionDropDown ClassID={classId} />
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Attendance month</label>
                    <select
                      className="form-select"
                      value={attMonth}
                      onChange={(e) => setAttMonth(parseInt(e.target.value, 10))}
                    >
                      {MONTH_OPTIONS.map((m) => (
                        <option key={m.value} value={m.value}>
                          {m.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Attendance year</label>
                    <select
                      className="form-select"
                      value={attYear}
                      onChange={(e) => setAttYear(parseInt(e.target.value, 10))}
                    >
                      {yearOpts().map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Challan (invoice) month</label>
                    <select
                      className="form-select"
                      value={invMonth}
                      onChange={(e) => setInvMonth(parseInt(e.target.value, 10))}
                    >
                      {MONTH_OPTIONS.map((m) => (
                        <option key={`i-${m.value}`} value={m.value}>
                          {m.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Challan year</label>
                    <select
                      className="form-select"
                      value={invYear}
                      onChange={(e) => setInvYear(parseInt(e.target.value, 10))}
                    >
                      {yearOpts().map((y) => (
                        <option key={`iy-${y}`} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12">
                    <label className="form-label d-block">Fine type</label>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="fineKind"
                        id="fkAbsent"
                        checked={fineKind === "Absent"}
                        onChange={() => setFineKind("Absent")}
                      />
                      <label className="form-check-label" htmlFor="fkAbsent">
                        Absent (A / AB) — fee code <strong>003</strong>
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="fineKind"
                        id="fkLate"
                        checked={fineKind === "Late"}
                        onChange={() => setFineKind("Late")}
                      />
                      <label className="form-check-label" htmlFor="fkLate">
                        Late comer (LC) — fee code <strong>004</strong>
                      </label>
                    </div>
                  </div>

                  {fineKind === "Absent" ? (
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="tier"
                          checked={tierAbsent}
                          onChange={(e) => setTierAbsent(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="tier">
                          Tier by class name (junior: PLAY GROUP–VIII = first rate; IX–XII = second rate),
                          matching your old SQL
                        </label>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-md-4">
                    <label className="form-label">
                      {fineKind === "Late"
                        ? "Rs per late occurrence"
                        : tierAbsent
                          ? "Rs per absent day (junior tier)"
                          : "Rs per absent day"}
                    </label>
                    <input
                      type="number"
                      min={1}
                      className="form-control"
                      value={rateJunior}
                      onChange={(e) => setRateJunior(parseInt(e.target.value, 10) || 0)}
                    />
                  </div>
                  {fineKind === "Absent" && tierAbsent ? (
                    <div className="col-md-4">
                      <label className="form-label">Rs per absent day (IX–XII)</label>
                      <input
                        type="number"
                        min={1}
                        className="form-control"
                        value={rateSenior}
                        onChange={(e) => setRateSenior(parseInt(e.target.value, 10) || 0)}
                      />
                    </div>
                  ) : null}

                  <div className="col-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="mergeFeeLine"
                        checked={mergeExistingFeeLine}
                        onChange={(e) => setMergeExistingFeeLine(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="mergeFeeLine">
                        Merge into existing fee line on challan (recommended after fee posting): if fee code{" "}
                        <strong>003</strong> or <strong>004</strong> already exists on the same challan head,
                        add amounts to that row instead of inserting a duplicate line.
                      </label>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="replaceM"
                        checked={replaceMonthly}
                        onChange={(e) => setReplaceMonthly(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="replaceM">
                        Issue new challan number (replace monthly head): soft-delete the open challan, bump
                        sequence, clone AD lines, then attach fines. Leave unchecked to keep the challan number
                        from fee posting.
                      </label>
                    </div>
                  </div>

                  <div className="col-12 d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className="button button-white"
                      disabled={loadingPreview || posting}
                      onClick={runPreview}
                    >
                      {loadingPreview ? (
                        <>
                          <Spinner size="sm" animation="border" className="me-2" />
                          Preview…
                        </>
                      ) : (
                        "Preview"
                      )}
                    </button>
                    <button
                      type="button"
                      className="button button-primary"
                      disabled={posting || loadingPreview || !previewRows.length}
                      onClick={runPost}
                    >
                      {posting ? (
                        <>
                          <Spinner size="sm" animation="border" className="me-2" />
                          Posting…
                        </>
                      ) : (
                        "Post fines"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {previewRows.length > 0 ? (
              <div className="card">
                <div className="card-header">Preview ({previewRows.length} students)</div>
                <div className="card-body table-responsive p-0">
                  <table className="table table-sm table-bordered mb-0 align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>ID</th>
                        <th>Reg no</th>
                        <th>Name</th>
                        <th>Class</th>
                        <th className="text-end">Occurrences</th>
                        <th className="text-end">Rate</th>
                        <th className="text-end">Total Rs</th>
                      </tr>
                    </thead>
                    <tbody>
                      {previewRows.map((r, i) => (
                        <tr key={r.Student_ID ?? r.student_ID ?? i}>
                          <td>{r.Student_ID ?? r.student_ID}</td>
                          <td>{r.Registration_No ?? r.registration_No}</td>
                          <td>{r.Student_Name ?? r.student_Name}</td>
                          <td>{r.Class_Name ?? r.class_Name}</td>
                          <td className="text-end">{r.Occurrences ?? r.occurrences}</td>
                          <td className="text-end">{r.RatePerOccurrenceApplied ?? r.ratePerOccurrenceApplied}</td>
                          <td className="text-end">{r.TotalAmount ?? r.totalAmount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default AttendanceFineBatch;
